import { ReactElement } from 'react';
import { Box, Button, Card } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { GlobusErrorMessageTypeEnum, GlobusErrorsSolutions } from "./GlobusErrorsSolutions";
import { LS_ERROR, TGlobusError } from "../../hooks/useGlobusTransfer";
import GlobusError from './components/GlobusError';

type GlobusErrorWrapperProps = {
    isSuccess: boolean;
    isAuthenticated: boolean;
    globusError: TGlobusError;
    reload: () => void;
    login: (param: any) => void;
    reauth: () => void;
}

const Wrapper = ({ children }: { children: ReactElement }) => {
    return (
        <Box sx={{
            width: '100%'
        }}>
            {children}
        </Box>
    )
}

const GlobusErrorView = ({
    isSuccess,
    isAuthenticated,
    globusError,
    reload,
    login,
    reauth
}: GlobusErrorWrapperProps) => {

    const solutionDetails = globusError ? GlobusErrorsSolutions[globusError.code] : GlobusErrorsSolutions["UNAUTHORIZED"];

    const renderActionButton = () => {
        const isNotAuthenticatedOrHasError = !isAuthenticated || (!isSuccess && globusError?.message === LS_ERROR.INVALID_PERMISSION);
        if (isNotAuthenticatedOrHasError) {
            return (
                <Button variant="primary" onClick={() => login({})}>
                    Authorize Lasso for Globus Transfer
                </Button>
            );
        }

        const hasGlobusError = !isSuccess && globusError?.message === LS_ERROR.REAUTH_REQUIRED;
        if (hasGlobusError) {
            return (
                <Button variant="primary" onClick={() => reauth()}>
                    Reauthorize
                </Button>
            );
        }

        return (
            <Button startIcon={<ReplayIcon/>} variant="contained" onClick={() => reload()}>
                Try again
            </Button>
        );
    }

    return (
        <Wrapper>
            {
                solutionDetails?.type === GlobusErrorMessageTypeEnum.FULLSCREEN ?
                    <GlobusError globusError={globusError} solutionDetails={solutionDetails} action={reload}/>
                    :
                    <Card sx={{ width: '60%', paddingY: '1rem', paddingX: '1.5rem', marginInline: 'auto' }}>
                        <GlobusError globusError={globusError} solutionDetails={solutionDetails}/>

                        <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                            {renderActionButton()}
                        </Box>
                    </Card>
            }
        </Wrapper>
    )
}

export default GlobusErrorView;